import { render, staticRenderFns } from "./createApp.vue?vue&type=template&id=0f271117&scoped=true"
import script from "./createApp.vue?vue&type=script&lang=js"
export * from "./createApp.vue?vue&type=script&lang=js"
import style0 from "./createApp.vue?vue&type=style&index=0&id=0f271117&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f271117",
  null
  
)

export default component.exports